/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Contentlabel1Inputs */

const he_posts_contentlabel1 = /** @type {(inputs: Posts_Contentlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תוכן`)
};

const en_posts_contentlabel1 = /** @type {(inputs: Posts_Contentlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content`)
};

/**
* | output |
* | --- |
* | "Content" |
*
* @param {Posts_Contentlabel1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const posts_contentlabel1 = /** @type {((inputs?: Posts_Contentlabel1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Contentlabel1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_contentlabel1(inputs)
	return en_posts_contentlabel1(inputs)
});
export { posts_contentlabel1 as "posts_contentLabel" }